// extracted by mini-css-extract-plugin
export default {"field":"RadioButton_field__BAqui","smallDeviceLabel":"RadioButton_smallDeviceLabel__LE5qK"};